// extracted by mini-css-extract-plugin
export default {"items":"Breadcrumbs-module__[local]___QQY6Y"};